const getters = {
  mubanInfo: state => state.design.mubanInfo,
  fullscreenLoading: state => state.design.fullscreenLoading,
  menuList: state => state.design.menuList,
  chooseMenuId: state => state.design.chooseMenuId,
  templateList: state => state.design.templateList,
  chooseComponentId: state => state.design.chooseComponentId,
  hasChanged: state => state.design.hasChanged,
  currentInfo: state => state.design.currentInfo,
  currentIndex: state => state.design.currentIndex,
  addDialogVisible: state => state.design.addDialogVisible,
  addDialogSingle: state => state.design.addDialogSingle,
  singleIndex: state => state.design.singleIndex,
  isChangeIndex: state => state.design.isChangeIndex,
  addRemark: state => state.design.addRemark
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js